
import { mapGetters } from 'vuex'
import { ButtonBox } from '@/components/atoms'
import { HydratedSearchList as SearchList } from '@/components/molecules'
import GLOBAL_COUNTRY from '~/utils/constants/global-country.json'
import { Country } from '~/store/context/interfaces'

const SEARCH_TOPIC = 'country'

export default {
  name: 'SearchCountries',
  components: {
    ButtonBox,
    SearchList,
  },
  computed: {
    ...mapGetters('context', ['countries', 'direction', 'language']),
    filteredCountries(): Country[] {
      return this.countries.filter(
        country => country.code !== GLOBAL_COUNTRY.code
      )
    },
  },
  methods: {
    itemClicked(countryCode): void {
      this.$emit('item-clicked', countryCode.toLowerCase())
    },
    onSearchInputFocus(): void {
      this.$gtmEnhanced.searchInput(SEARCH_TOPIC)
    },
    onCountriesSearch(searchTerm): void {
      this.$gtmEnhanced.viewSearchResults(searchTerm, SEARCH_TOPIC)
    },
  },
}
